import { render } from "./BasePieChart.vue?vue&type=template&id=7b5ea1af&scoped=true"
import script from "./BasePieChart.vue?vue&type=script&lang=js"
export * from "./BasePieChart.vue?vue&type=script&lang=js"

import "./BasePieChart.vue?vue&type=style&index=0&id=7b5ea1af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5ea1af"]])

export default __exports__